import { Entity, Type } from "@jobilla/entity";
import { Money } from "./money";

export class Product extends Entity {
  id!: string;
  title!: string;
  sku!: string;

  @Type(Money)
  price!: Money;

  get isTargetProduct() {
    return ["DH", "DH-LITE", "DH-PRO", "GU-MTG"].includes(this.sku);
  }

  get isProductWithToken() {
    return ["DH", "DH-LITE", "DH-PRO", "CC"].includes(this.sku);
  }
}
